import { gsap } from "gsap";

const BouncingText = () => {
  const mainCopies = document.querySelectorAll('.js-fv-path');
  
  if (mainCopies.length === 0) {
    console.warn('.js-fv-pathが見つかりませんでした');
    return;
  }
  
  // 初回の開始遅延時間（秒）
  const initialDelay = 2;
  
  // 各.js-fv-pathに対してアニメーションを作成
  mainCopies.forEach((mainCopy, index) => {
    // 子要素のpathをすべて取得
    const paths = mainCopy.querySelectorAll('.js-animation-path');
    
    if (paths.length === 0) {
      console.warn(`${index + 1}番目の.js-fv-path内にpathが見つかりませんでした`);
      return;
    }
    
    // 初期状態を設定
    gsap.set(paths, {
      y: 0,
      opacity: 1
    });
    
    // 前のアニメーションの総時間を計算
    const animationDuration = 0.6;
    const staggerDuration = paths.length * 0.03;
    const totalDuration = animationDuration + staggerDuration;
    const interval = 1;
    
    // 各アニメーションの開始遅延時間を計算（初回遅延を追加）
    const delay = initialDelay + index * (totalDuration + interval);
    
    // ループアニメーションの作成
    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: interval + (totalDuration + interval) * (mainCopies.length - 1),
      delay: delay
    });
    
    // 弾むアニメーション（反対方向から開始）- 重ねて滑らかに
    tl.to(paths, {
      y: -20,
      duration: 0.2,
      stagger: {
        each: 0.03,
        from: "end"
      },
      ease: 'power2.out'
    })
    .to(paths, {
      y: 0,
      duration: 0.2,
      stagger: {
        each: 0.03,
        from: "end"
      },
      ease: 'power2.inOut'
    }, '-=0.2'); // 0.2秒前から開始（重ねる）
  });
};

const init = () => {
  BouncingText();
};

export default init;